// DepartmentTab.js
import { Grid, Typography, Box, Button, TextField, InputAdornment } from "@mui/material";
import { DataGridPro } from "@mui/x-data-grid-pro";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import { toast, ToastContainer } from "react-toastify";
import DepartmentDialog from "screens/Employees/component/Department";
import { useDepartmentLogic } from "../logic/DepartmentTabLogic";

const DepartmentTab = () => {
  const { DepartmentProps } = useDepartmentLogic(toast);

  const {
    handleOpenDepartmentDlg,
    columns,
    paginationModel,
    setPaginationModel,
    openDepartmentDlg,
    handleCloseDepartmentDlg,
    rows,
    loading,
    searchQuery,
    handleSearchChange,
    filteredRows,
  } = DepartmentProps;

  return (
    <>
      <Grid container spacing={5}>
        <Grid item xs={12}>
          <Box
            sx={{
              display: "flex",
              flexDirection: { xs: "column", lg: "row" },
              justifyContent: "space-between",
              alignItems: { xs: "flex-start", lg: "center" },
              gap: { xs: 2, lg: 0 },
            }}
          >
            <Box>
              <Typography variant="h3">Departments</Typography>
              <Typography color="secondary">
                Manage your desired Departments in the system.
              </Typography>
            </Box>
            <Box sx={{ display: "flex", gap: 4, alignItems: "center" }}>
              <TextField
                placeholder="Search departments..."
                value={searchQuery}
                onChange={handleSearchChange}
                size="small"
                sx={{
                  width: { xs: "100%", sm: 300 },
                  "& .MuiOutlinedInput-root": {
                    borderRadius: 1,
                  }
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon color="action" />
                    </InputAdornment>
                  ),
                }}
              />
              <Button
                variant="contained"
                color="main"
                startIcon={<AddIcon />}
                onClick={handleOpenDepartmentDlg}
                sx={{
                  whiteSpace: 'nowrap'
                }}
              >
                Create Department
              </Button>
            </Box>
          </Box>
        </Grid>
        <Grid item xs={12}>
          <DataGridPro
            // pagination
            rows={filteredRows || rows || []}
            rowHeight={62}
            columns={columns || []}
            // pageSizeOptions={[
            //   10,
            //   50,
            //   { value: (filteredRows || rows || []).length, label: "Show All" },
            // ]}
            disableRowSelectionOnClick
            // paginationModel={paginationModel}
            // onPaginationModelChange={setPaginationModel}
            sx={{
              minHeight: 280,
              maxHeight: 600,
              "& .MuiDataGrid-columnHeaderTitle": {
                textTransform: "none",
              },
            }}
            slots={{
              footer: () => null
            }}
          />
        </Grid>
      </Grid>

      {/*<ToastContainer />*/}

      <DepartmentDialog
        open={openDepartmentDlg}
        handleClose={handleCloseDepartmentDlg}
        DepartmentProps={DepartmentProps}
      />
    </>
  );
};

export default DepartmentTab;